import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FaBars, FaTimes } from 'react-icons/fa';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const handleLogout = () => {
    logout();
    window.location.href = '/admin/login';
  };

  let navLinks = [];
  if (user?.role === 'superadmin') {
    navLinks = [
      { to: '/admin/dashboard', label: 'Dashboard' },
      { to: '/admin/orders', label: 'Orders' },
      { to: '/admin/products', label: 'Products' },
      { to: '/admin/shipping', label: 'Shipping' },
      { to: '/admin/analytics', label: 'Analytics' },
      { to: '/admin/admins', label: 'Admin Management' },
      { to: '/admin/register-admin', label: 'Register Admin' },
    ];
  } else if (user?.role === 'admin') {
    navLinks = [
      { to: '/admin/orders', label: 'Orders' },
      { to: '/admin/products', label: 'Products' },
    ];
  }

  return (
    <div className="flex min-h-screen h-full bg-gradient-to-br from-blue-50 to-yellow-50">
      {/* Mobile Hamburger */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 bg-gradient-to-br from-blue-700 to-blue-500 text-white p-2 rounded shadow-lg focus:outline-none"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open sidebar"
      >
        <FaBars size={24} />
      </button>
      {/* Sidebar Drawer */}
      <div
        className={`fixed inset-0 z-40 md:static md:inset-auto md:z-auto transition-all duration-300 ${sidebarOpen ? 'block' : 'hidden md:block'}`}
      >
        {/* Overlay for mobile */}
        <div
          className={`fixed inset-0 bg-black bg-opacity-40 transition-opacity duration-300 ${sidebarOpen ? 'block md:hidden' : 'hidden'}`}
          onClick={() => setSidebarOpen(false)}
        />
        <aside
          className={`w-4/5 max-w-xs md:w-64 h-full flex flex-col bg-gradient-to-br from-blue-700 to-blue-500 text-white py-8 px-4 shadow-2xl border-r border-blue-200 z-50
            ${sidebarOpen ? 'fixed top-0 left-0 translate-x-0' : '-translate-x-full'}
            md:static md:translate-x-0 md:top-auto md:left-auto
            transition-transform duration-300 overflow-y-auto pb-24 flex-grow`}
        >
          {/* X button row for mobile */}
          <div className="flex items-center justify-between md:hidden mb-4">
            <div />
            <button
              className="text-white focus:outline-none"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar"
            >
              <FaTimes size={28} />
            </button>
          </div>
          <div className="flex flex-col items-center justify-center mb-8 mt-6">
            <img
              src={user?.avatarUrl && user.avatarUrl.trim() !== '' ? user.avatarUrl : (user?.avatar && user.avatar.trim() !== '' ? user.avatar : '/images/placeholder.jpg')}
              alt="avatar"
              className="w-16 h-16 rounded-full border-2 border-white shadow-md object-cover mb-2"
              onError={e => { e.target.onerror = null; e.target.src = '/images/placeholder.jpg'; }}
            />
            <div className="font-semibold text-base text-center truncate w-full max-w-[140px]">
              {user?.firstName || user?.name || 'Admin'} {user?.lastName || ''}
            </div>
            <div className="text-xs text-blue-100 text-center truncate w-full max-w-[140px]">
              {user?.email || ''}
            </div>
            {user?.status && (
              <div className={`mt-1 text-xs px-2 py-1 rounded-full font-semibold ${user.status === 'active' ? 'bg-green-500 text-white' : 'bg-gray-400 text-white'}`}>
                {user.status === 'active' ? 'Active' : 'Inactive'}
              </div>
            )}
          </div>
          <div className="flex items-center justify-between mb-8 md:mb-8">
            <div className="text-lg md:text-2xl font-bold mt-2">Admin Panel</div>
          </div>
          <nav className="flex-1 flex flex-col gap-2 md:gap-4">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`hover:bg-blue-800 rounded px-2 md:px-3 py-2 transition-colors ${location.pathname === link.to ? 'bg-blue-900' : ''}`}
                onClick={() => setSidebarOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </nav>
          {/* Logout button for mobile, at the bottom with margin */}
          <button onClick={handleLogout} className="md:hidden mb-12 mt-8 bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded shadow transition-colors w-full">Logout</button>
          {/* Logout button for desktop, at the bottom */}
          <button onClick={handleLogout} className="mt-8 bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded shadow transition-colors w-full hidden md:block">Logout</button>
        </aside>
      </div>
      {/* Main Content */}
      <main className="flex-1 h-full flex flex-col p-2 md:p-8 transition-all duration-300 overflow-x-auto mt-16 md:mt-0 w-full">
        <div className="max-w-full flex-grow">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout; 